<template>
<div>
    <footer class="main-footer" v-if="exibefooter">
        <div class="center">
            <div class="site-map">
                <img src="../Content/images/logo_.png" class="logo-footer">
                <div class="menu-footer">
                    <p class="title-menu">PLANOS</p>
                    <div class="row">
                        <div class="col">
                            <a planojuridico href="https://www.primavida.com.br/prefeiturasp"><strong>Prefeitura São Paulo</strong><i class="fas fa-angle-right"></i></a>
                            <a planojuridico href="https://www.primavida.com.br/adesaopessoafisica/"><i class="fas fa-angle-right"></i> Pessoa Física</a>
                            <!--<router-link to="/pessoafisica"><i class="fas fa-angle-right"></i> Pessoa Física</router-link>-->
                            <!-- <a @click.prevent="exibeMsgConstrucao()" >Servidor Público</a>  -->
                            <!-- <a @click="exibeMsgConstrucao()">Pessoa Jurídica</a> -->
                            <!--<router-link to="/servidorpublico"><i class="fas fa-angle-right"></i> Servidor Público</router-link>-->
                            <a planojuridico href="https://www.primavida.com.br/prefeiturasp"><i class="fas fa-angle-right"></i> Servidor Público</a>
                            <router-link to="/pessoajuridica"><i class="fas fa-angle-right"></i> Pessoa Jurídica</router-link>
                            
                        </div>
                        <div class="col">
                            <a href="https://www.primavida.com.br/redecredenciada">Rede Credenciada</a>
                            <router-link to="/contato"><i class="fas fa-angle-right"></i> Contato</router-link>
                            <router-link to="/areacliente" >Área do Cliente</router-link>
                            <a href="https://primavida.s4e.com.br/SYS/" >Área de Acesso</a>
                        </div>
                        <div class="col">
                            <a v-if="userloggedin" @click="Sair"><i class="fas fa-angle-right"></i> Sair</a>
                        </div>
                    </div>
                </div>
            </div>
            <img src="../Content/images/logo-ans.png" alt="">
        </div>
    </footer>
    <v-card
      class="flex"
      flat
      tile
    >
      <v-card-title class="grey lighten-5">
        <v-layout row wrap class="justify-center">
            <v-flex xs12 sm12 lg3 style="text-align: center;">
                <p class="tituloRep">Sede</p>
                <p class="textoRep">Av. Rio Branco,123 - Salas 2106 a 2111</p>
                <p class="textoRep">Centro - Rio de Janeiro RJ CEP 20040-905</p>
                <p class="textoRep">Tel. (21) 3299.4500</p>
            </v-flex>
            <v-flex xs12 sm12 lg3 style="text-align: center;">
                <p class="tituloRep">Representante Autorizado SP</p>
                <p class="textoRep">Praça Santo Agostinho, 70 – Conj. 94</p>
                <p class="textoRep">Aclimação São Paulo SP - CEP 01.533-070</p>
                <p class="textoRep">Tel. (11) 2307.2360 / 2307.2365</p>
            </v-flex>
            <v-flex xs12 sm12 lg3 style="text-align: center;">
                <p class="tituloRep">Representante Autorizado MG</p>
                <p class="textoRep">Av. Alvares Cabral, 397 / 13º andar – Lourdes</p>
                <p class="textoRep">Belo Horizonte MG - CEP 30170-001</p>
                <p class="textoRep">Tel. (31) 3212.7657</p>
            </v-flex>
            <v-flex xs12 sm12 lg3 style="text-align: center;">
                <p class="tituloRep">Representante Autorizado RO</p>
                <p class="textoRep">R. das Orquuídea, 2235 – sala 10 setor 04</p>
                <p class="textoRep">Ariquemes – RO CEP: 76873-508</p>
                <p class="textoRep">Tel. (69) 2103.2156</p>                
            </v-flex>
        </v-layout>
      </v-card-title>

      <!-- <v-card-actions class="grey darken-3 justify-end">
        <p  style="color:#f3f1f1;font-size: 12px;">Desenvolvido por &nbsp;</p>
        <a href="http://www.intelitetecnologia.com.br/" target="_blank" style="margin-bottom: -8px;"><img src="../Content/images/intelite.png" alt="" width="100px" ></a>
      </v-card-actions>      
    </v-card>-->

    <div class="whatsappIcon">
      <a target="_blank" href="https://wa.me/552132994501?text=Olá">     
        <img height="60" src="../assets/whatsapp.png"/>
      </a>
    </div>
    <Snackbar ref=chamaSnackbar />
</div>
</template>

<script>
import Snackbar from '../components/snackbar.vue'
import { mapState } from 'vuex'
export default {

    components: {Snackbar},
    data(){
        return{

        }
    },
    computed: {
       ...mapState({
        userloggedin: state => state.userloggedin,
        exibefooter: state => state.isFooterVisible
    })
    },
/*     mounted : function(){
      this.$store.dispatch('Logar')
    }, */
    methods: {
    Sair(){
            this.$store.dispatch('Sair')
            this.$router.push({ path: '/areacliente' })
        },
    exibeMsgConstrucao(){
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#0288D1","Disponível em breve!","INFORMAÇÃO")
        }
    }
}
/*import sha256 from 'crypto-js/sha256';

const email = sha256('agenciaboomcriativo@gmail.com').toString();
const phone = sha256('5591980418976').toString();

fetch('http://localhost:3001/api/fb-event', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    event_name: 'Lead', // ou Purchase, etc
    user_data: {
      em: [email],
      ph: [phone]
    },
    custom_data: {
      value: 100.00,
      currency: 'BRL'
    }
  })
});*/
</script>


<style>
    .whatsappIcon {
      position: fixed;
      bottom: 70px;
      right: 0px;
      clear: both;
    }

    .whatsappIcon img:hover {
      transition: 0.4s;
      -webkit-transform: scale(1.2);
      -moz-transform: scale(1.2);
      -o-transform: scale(1.2);
      -ms-transform: scale(1.2);
      transform: scale(1.2);
    }

    .whatsappIcon img {
      transition: 0.4s;
      -webkit-transform: scale(1);
      -moz-transform: scale(1);
      -o-transform: scale(1);
      -ms-transform: scale(1);
      transform: scale(1);
    }

    .tituloRep{
        color:#666;
        font-weight: bold;
        font-size: 14px;
    }
    .textoRep{
        color:#666;
        font-size: 14px;
    }
</style>
